// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".position-point{position:absolute;width:100%;height:100%;overflow:hidden}.position-point .position{height:calc(100% - 50px);overflow-y:scroll}.position-point .position .point-map-wrap{box-sizing:border-box;padding-right:10px;padding-left:10px}.position-point .position .point-map{height:300px}", ""]);
// Exports
module.exports = exports;
